import { render, staticRenderFns } from "./wo002.vue?vue&type=template&id=3bb7fa56"
import script from "./wo002.vue?vue&type=script&lang=js"
export * from "./wo002.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bb7fa56')) {
      api.createRecord('3bb7fa56', component.options)
    } else {
      api.reload('3bb7fa56', component.options)
    }
    module.hot.accept("./wo002.vue?vue&type=template&id=3bb7fa56", function () {
      api.rerender('3bb7fa56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/imsi/sample/wo002.vue"
export default component.exports